window.addEventListener("scroll", pageTop_position, false);
window.addEventListener("load", gap, false);
window.addEventListener("resize", gap, false);
jQuery(function() {
    nuvSubSp();
    pageTop_position();
    multilingual();
    commons();
    policiesAddBreadcrumbs();
});
nuvSub();
gap();
function multilingual() {
    var $body = $('body');
    if ($body.hasClass('jp')) {
        $('.cn-more-info').attr('data-link-url', '/home_jp/cookiepolicy/');
        $('.cn-text-container').text('当サイトでは、ユーザーエクスペリエンスを向上させるためにCookieを使用しています。詳細については、[Cookieポリシー]をお読みください。');
    }
}
function gap() {
    function addClassBasedOnElementWidth(selector, className) {
        document.querySelectorAll(selector).forEach(function(element) {
            const elementWidth = element.clientWidth;
            if (elementWidth < 1200) {
                element.classList.add(className + '-small');
            } else {
                element.classList.remove(className + '-small');
            }
        });
    }
    addClassBasedOnElementWidth('[class*="flex-"], [class*="grid-"]', 'container');
}
function commons() {
    $('.trigger').click(function() {
        $('.nav-open').toggleClass("active");
        $('.nav-content').toggleClass("active");
    });
    $('.card-question-title').on('click', function() {
        $(this).toggleClass('active');
        $(this).next('.answer-wrap').slideToggle();
    });
    $('[data-link]').click(function() {
        $('.explanation').removeClass('active');
        $($(this).attr('data-link')).addClass('active');
    });
    $(window).on("load resize", function() {
        $('.box-back_img').each(function() {
            var ww = $(window).width();
            var background = $(this).data('back');
            $(this).css('background', 'url("' + background + '") center / cover no-repeat');
            if ($(this).data('back_sp')) {
                var background_sp = $(this).data('back_sp');
                if (ww < 640) {
                    $(this).css('background', 'url("' + background_sp + '") center / cover no-repeat');
                }
            }
        });
    });
    $('.main-visual[data-back]').each(function() {
        var background = $(this).data('back');
        $(this).css('background', '#ccc url("' + background + '") center / cover no-repeat');
        $(this).css('background-blend-mode', 'multiply');
    });
    $('.tab-wrap .tab-content:first-child').show();
    $('.list-tab-label li').click(function() {
        $(this).parents('.box-model').find('.tab-content').hide();
        $($(this).find('a').attr('href')).fadeIn();
        var slug = $(this).attr('data-action');
        $(".body-position").fadeOut(100);
        setTimeout(function() {
            $(".body-position img").attr("src", "images/" + slug + ".png");
        }, 100);
        $(".body-position").fadeIn(100);
        return false;
    });
    $('.button-archive').prepend('<span class="line"></span><span class="line"></span>');
    $('.button-section a').prepend('<span class="line"></span><span class="line"></span>');
    $('.question-content:first-child').show();
    $('.question-content a[link]').click(function() {
        $('.question-content').hide();
        $($(this).attr('link')).fadeIn();
    });
    var windowWidth = $(window).width();
    var windowSm = 640;
    if (windowWidth <= windowSm) {
        $('.scroll').before('<p class="scroll-pointer">scroll</p>');
    }
}
var nodelist = document.querySelectorAll(".drawer-nav [href^='#']");
nodelist.forEach(function(element) {
    element.addEventListener("click", function() {
        document.getElementById("nav-input").checked = false;
    }, false);
});
function pageTop_position() {
    var scrollTop = window.pageYOffset;
    var element = document.getElementById("js-pagetop");
    if (scrollTop > 0) {
        element.classList.add("active");
    } else {
        element.classList.remove("active");
    }
    $(window).scroll(function() {
        var scrollHeight = $(document).height();
        var scrollPosition = $(window).height() + $(window).scrollTop();
        var footHeight = $("footer").innerHeight();
        if (scrollHeight - scrollPosition <= footHeight) {
            $("#js-pagetop").css({
                "position": "absolute",
                "bottom": footHeight + 0
            });
        } else {
            $("#js-pagetop").css({
                "position": "fixed",
                "bottom": "0px"
            });
        }
    });
}
function nuvSub() {
    var nodelist = document.querySelectorAll(".global-nav .menu-item-has-children");
    nodelist.forEach(function(element) {
        element.addEventListener("mouseover", function() {
            element.querySelector(".sub-menu").classList.add("active");
        }, false);
        element.addEventListener("mouseout", function() {
            element.querySelector(".sub-menu").classList.remove("active");
        }, false);
    });
}
function nuvSubSp() {
    var allItem = jQuery(".drawer-nav li");
    var allItemCount = allItem.length;
    for (var i = 0; i < allItemCount; i++) {
        if (jQuery(allItem[i]).children(".sub-menu").length) {
            jQuery(allItem[i]).prepend("<button class='btn-sub fas fa-angle-down'></button>");
        }
    }
    jQuery(".btn-sub").on("click", function() {
        jQuery(this).toggleClass("fa-angle-up fa-angle-down").nextAll(".sub-menu").stop().slideToggle();
    });
}

function policiesAddBreadcrumbs() {
    const $policyTitle = $('.shopify-policy__container .shopify-policy__title');
    if ( $policyTitle.length == 0 ) return;
    const $policyTitleH1 = $policyTitle.find('h1');
    if ( $policyTitleH1.length == 0 ) return;
    const policyTitleText = $policyTitleH1.text().trim();
    if ( !policyTitleText ) return;
    let breadcrumbHtml = `<div class="breadcrumbSection tanilayout">
        <div class="page-width page-width--narrow">
            <ul class="breadcrumb" itemscope="" itemtype="http://schema.org/BreadcrumbList">
                <li itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ListItem">
                    <a href="/" itemprop="item">
                        <span itemprop="name">Home</span>
                        <meta itemprop="position" content="1">
                    </a>
                </li>
                <li itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ListItem">
                    <span itemprop="name">${policyTitleText}</span>
                    <meta itemprop="position" content="2">
                </li>
            </ul>
        </div>
    </div>
    `;
    $policyTitle.after(breadcrumbHtml);
}